import React from "react";
import ReactDom from "react-dom";
import { Navigation, Link, Router } from "react-router";
import AppHeader from "js/components/elements/sdk-header";
import { ZOOM_ICON } from "js/config.jsx";
import UserHandler from "js/utilities/user-handler";
import Validate from "js/utilities/validate";
import NoHal, {halCheck} from "js/utilities/no-hal";
import LogErrrorsToZoomCloud from "js/utilities/log-errors-to-zc"
import LoginButton from "html-components/LoginButton";
import Amplitude from "js/utilities/amplitude";
import TimerMixin from "react-timer-mixin";
import styles from "html-components/LoginButton.css";
import * as config from "../../config";

export default React.createClass({
  mixins: [Navigation],

  statics: {
    includeHeaderFooter: false
  },

  getInitialState: function() {
    return {
      error: null,
      loading: false,
      loaded: false,
      agreedToTOC: false,
      email: ""
    };
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  componentWillMount: function() {
    if (UserHandler.loggedIn()) {
      return this.context.router.push("/docs");
    }

    this.setState({email: UserHandler.getResendEmail()});
  },

  toast: function(message) {
    var elem = document.getElementById("toast");
    elem.innerHTML = message;
    elem.className = "show";
    setTimeout(function(){
      elem.className = elem.className.replace("show", "");
      // yes this is not recommended, but we dont need to re render
      this.state.error = null
    }.bind(this), 5000);
  },

  handleEmailChange(event) {
    this.setState({email: event.target.value});
  },

  render: function() {
    if (UserHandler.loggedIn()){ return false; }
    var url = window.location.origin;
    if (FN_MODE !== "qa") {
      url += "/zoomsdk";
      var terms = `https://dev.facetec.com/policies/terms.html`
    }
    else {
      var terms = `https://dev.facetec.com/policies/terms.html`
    }
    if (UserHandler.loggedIn()) {
      url += "/#docs"
    }
    else {
      url += "/#signin"
    }
    var currentButtonStyle = styles.loginbutton

    let errorMessage = UserHandler.getErrorMessage()
    var isErrorMessage = false;
    if(errorMessage) {
      isErrorMessage = true;
    }
    if (this.state.error) {
      this.toast(this.state.error);
    }
    return (
      <div className="bg">
        <div className="signin">
          <div className="box">
            <div className="header">
              <img src={ZOOM_ICON} className="img"/>
              <p className="sub-title">DEVELOPER ACCESS</p>
              <br />
            </div>
            {isErrorMessage == true ? (errorMessage== "authTokenAlreadyUsed"?<p className="loginerror">This login link was already used. Please click on below <span className="highlight">Sign Up/Sign In</span> button or <Link onClick={this.handleSubmit} className="highlight">Resend</Link> to receive email with new login link.</p> :<p className="loginerror">{errorMessage}</p>) : ""}
            <form autoComplete="off" onSubmit={this.handleSubmit}>
              <input id="input-email" ref="email" placeholder="Enter Your Email" type="email" value={this.state.email} onChange={this.handleEmailChange} autoFocus required/>
              <LoginButton buttonText="Sign Up / Sign In" style={currentButtonStyle} loading={this.state.loading} loaded={this.state.loaded}></LoginButton>
              <br />
              <br />
              <p className="smaller">By signing into your FaceTec Developer Account, <br />you are agreeing to our <a className="underline" href="https://dev.facetec.com/policies/terms.html" target="_blank">Terms &amp; Conditions</a></p>
              <NoHal/>
            </form>
          </div>
        </div>
        <div id="toast"/>
      </div>
    );
  },

  handleSubmit: function(event) {
    this.setState({error: null, loading: true, loaded: false});
    event.preventDefault();

    var creds = {
      email: this.refs.email.value
    };

    if (halCheck(creds.email, this)) {
      this.setState({loading:false});
      return
    }

    if (!Validate.email(creds.email)) {
      this.setState({error: "Please enter a valid email address", loading: false});
      return
    }

    // Instantiate Loggly
    _LTracker.push({
      "logglyKey": "98508576-85af-467e-8713-9ae93891800c",
      "tag" : "sdksite_debug_logs",
      "sendConsoleErrors": true
    });

    UserHandler.logToLogglySimple("signin.jsx - handleSubmit - start");

    var method = "POST";
    var fullURL = config.API_PREFIX + "user/auth-token/email";

    // Send up email as param
    var reqBody = creds

    var requestStartTime = Date.now();
    var request = new XMLHttpRequest();
    request.open(method, fullURL, true);
    request.setRequestHeader("Content-Type", "application/json");
    request.setRequestHeader("Accept", "application/json");

    var reqHeaders = {
      "Content-Type": "application/json",
      "Accept": "application/json",
    };

    var localContextThis = this;

    request.onerror = function() {
      UserHandler.logToLogglySimple("signin.jsx - handleSubmit - onerror 1 - fatal - 1601 - request.statusText: " + request.statusText);
      var apiCallTimeEndToEnd = Date.now() - requestStartTime;

      UserHandler.logToLogglyWithAPIResponse(
        "signin.jsx - handleSubmit - onerror 2 - fatal - 1601 - request.statusText: " + request.statusText,
        method,
        fullURL,
        reqHeaders,
        reqBody,
        "No responseText when errored.",
        apiCallTimeEndToEnd
      );

      var log = {
        "status": 999,
        "method": method,
        "ok": false,
        "url": fullURL,
        "reqBody": reqBody,
        "reqHeaders": reqHeaders,
        "originalError": request.statusText,
        "filename": "signin.jsx"
      };
      LogErrrorsToZoomCloud.sendLogs(logs, reqBody, reqHeaders);
      localContextThis.setState({loading: false, error: "There was an error (1601) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance."});

      return;
    };

    request.onload = function() {
      UserHandler.logToLogglySimple("signin.jsx - handleSubmit - onload 1");
      var apiCallTimeEndToEnd = Date.now() - requestStartTime;

      UserHandler.logToLogglyWithAPIResponse(
        "signin.jsx - handleSubmit - onload 2",
        method,
        fullURL,
        reqHeaders,
        reqBody,
        request.responseText,
        apiCallTimeEndToEnd
      );

      //
      // Check response for non-happy-path flags
      //
      var responseJSON;
      try {
        responseJSON = JSON.parse(request.responseText);
      }
      catch (e) {
        UserHandler.logToLogglySimple("signin.jsx - handleSubmit - onload - JSON.parse error - fatal - 1602 - error: " + e);
        var log = {
          "status": 999,
          "method": method,
          "ok": false,
          "url": fullURL,
          "reqBody": reqBody,
          "reqHeaders": reqHeaders,
          "originalError": request.statusText,
          "filename": "signin.jsx"
        };
        LogErrrorsToZoomCloud.sendLogs(logs, reqBody, reqHeaders);
        localContextThis.setState({loading: false, error: "There was an error (1602) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance."});
        return;
      }

      if(!responseJSON.meta || !responseJSON.meta.ok) {
        //
        // Check to see if ok exists but is false.  also check to make sure there is a message.
        // this is the case of "expected error"
        // we should show what this is to the user since it could be
        // something like their auth token has already been used (common)
        //
        if(responseJSON.meta.ok === false && responseJSON.meta.message) {
          UserHandler.logToLogglySimple("signin.jsx - handleSubmit - onload - meta response not ok - fatal - 1603");
          localContextThis.setState({loading: false, error: "There was an error (1603) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance."});
          return;
        }
        else {
          UserHandler.logToLogglySimple("signin.jsx - handleSubmit - onload - malformed response meta - fatal - 1605");
          localContextThis.setState({loading: false, error: "There was an error (1605) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance."});
          return;
        }
      }

      if(responseJSON && responseJSON.meta && responseJSON.meta.message) {
        var emailSentMessage = "An email has been sent."
        if(responseJSON.meta.message.indexOf(emailSentMessage) === 0) {
          localContextThis.context.router.push("/signin-email-sent?email=" + creds.email);
        }
        else {
          UserHandler.logToLogglySimple("signin.jsx - handleSubmit - onload - email send response incorrect - fatal - 1606");
          localContextThis.setState({loading: false, error: "There was an error (1606) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance."});
          return;
        }
      }
      else {
        UserHandler.logToLogglySimple("signin.jsx - handleSubmit - onload - email send response incorrect 2 - fatal - 1607");
        localContextThis.setState({loading: false, error: "There was an error (1607) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance."});
      }
    };

    request.send(JSON.stringify(reqBody));
    UserHandler.logToLogglySimple("signin.jsx - handleSubmit - sent");
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/signin.jsx